enum EEndpointProtocol {

    ODATA       = "odata",
    MVB_API     = "mvbapi",
    API         = "api"

}

export default EEndpointProtocol;
